module.exports = __webpack_public_path__ + "img/2-帮助.a3e55736.svg";